import { useTrustArc } from '@common/hooks'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getLocationState } from '@common/state/selectors'
import { EU_COUNTRIES } from '@common/constants/countries'
import styles from './trustarc.module.css'

export interface TrustArcProps {
    language?: string
}

export const TrustArc: FunctionComponent<TrustArcProps> = ({ language = '' }) => {
    const [selectedLang, setSelectedLang] = useState(language)
    const locationState = useSelector(getLocationState)
    const shouldLoadScript = locationState.isLocationInfoLoaded
    let isLogMeInDomain = false

    if (window.location.hostname.includes('logmein.com')) {
        isLogMeInDomain = true
    }

    const isEuropeanMarketCountry = (country: string) => {
        const countryCode = country.toUpperCase()
        return EU_COUNTRIES.has(countryCode) || countryCode === 'GB'
    }

    const isEU = isEuropeanMarketCountry(locationState.locationInfo.country)

    useEffect(() => {
        if (language !== selectedLang) {
            setSelectedLang(language)
            window.location.reload()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language])

    useTrustArc(shouldLoadScript, isEU, isLogMeInDomain, language)

    return <div id="consent_blackbar" className={styles.trustarc} />
}
